import { Button, Stack, Typography } from '@mui/material';
import ModalUI from 'components/common/ModalUI';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'routers/routes';

interface PopupInformCantPurchaseProps {
  onClose: () => void;
}

export function PopupInformCantPurchase({
  onClose,
}: PopupInformCantPurchaseProps) {
  const redirect = useNavigate();

  const backToCredits = () => {
    onClose();
    redirect(APP_ROUTES.CREDITS.OVERVIEW.to);
  };

  return (
    <ModalUI
      open
      onClose={onClose}
      hideCloseButton
      forceAction
      PaperProps={{
        sx: {
          width: 350,
          height: 'unset',
          margin: 3,
          borderRadius: 2,
          '& .MuiBox-root': { p: 3 },
        },
      }}
    >
      <Stack spacing={2.5} justifyContent={'center'} alignItems={'center'}>
        <Typography variant="Web_Title_18" color="primary.main">
          Cannot Purchase Package
        </Typography>
        <Typography
          textAlign={'center'}
          fontSize={14}
          fontWeight={700}
          color={'text.secondary'}
        >
          To purchase a package, you need to complete your first trial job
          first.
        </Typography>
        <Button variant="contained" onClick={backToCredits}>
          Back
        </Button>
      </Stack>
    </ModalUI>
  );
}

export default PopupInformCantPurchase;
